import { getWujiCompInstance } from '@/utils/comps-loader';
async function loadVuePreset() {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('vue3')) {
        await moduleManage.loadVue3Dependencies();
    }
}
async function loadReactPreset() {
    const wujiComp = getWujiCompInstance();
    const { moduleManage } = wujiComp;
    if (!moduleManage.webpackExternals?.includes('React')) {
        await moduleManage.loadReactDependencies();
    }
    const w = window;
    await Promise.all([
        // @ts-ignore
        import('@tencent/wuji-react/react').then((e) => {
            w.React = e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/react-dom').then((e) => {
            w.ReactDOM = e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/react-dom/client').then((e) => {
            w.ReactDOMClient = e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/react-router-dom').then((e) => {
            w.ReactRouterDOM = w.ReactRouterDOM || e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/react/jsx-runtime').then((e) => {
            w.ReactJSXRuntime = e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/react/jsx-dev-runtime').then((e) => {
            w.ReactJSXDevRuntime = e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/zustand').then((e) => {
            w.Zustand = w.Zustand || e;
        }),
        // @ts-ignore
        import('@tencent/wuji-react/zustand/shallow').then((e) => {
            w.ZustandShallow = e;
        }),
    ]);
}
export async function loadFrameworkPreset(framework) {
    if (framework === 'react') {
        await loadReactPreset();
    }
    else {
        await loadVuePreset();
    }
}
